import * as React from "react";
import {withStyles} from "@mui/styles";
import {selectors as adminSelectors} from "../../../Ducks/admin";
import {actions as usersActions, selectors as usersSelectors} from "../../../Ducks/users";
import {actions as companiesActions, selectors as companiesSelectors} from '../../../Ducks/companies';
import {selectors as accountSelectors} from "../../../Ducks/account";
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import {useParams} from "react-router-dom";
import {Button, CircularProgress, FormControl, FormControlLabel, Grid, InputLabel, MenuItem, Select, Switch, Typography} from "@mui/material";
import {Check, Restore} from "@mui/icons-material";
import TeamUsersGrid from "./Grid/TeamUsersGrid";
import AddTeam from "./Modal/AddTeam";
import editIcon from '../../../Assets/images/editIcon.png'

const useStyles = (_theme) => ({
    container: {
        textAlign: "left",
        maxWidth: "90%",
        margin: "0 auto"
    },
    roles: {
        display: 'flex',
        flexDirection: "column !important",
        '& > div': {
            display: 'flex',
            '& > button': {
                width: '100%',
                marginBottom: "10px",
                fontWeight: "bold",
                "&.selected": {
                    background: "#002ea7",
                    color: "#fff",
                    "& + div > .deleteRole": {
                        display: 'none'
                    },
                    "& + div > .updateTeam": {
                        display: 'block',
                        "& > img": {
                            background: '#fff'
                        }
                    }
                }
            }
        }
    },
    box: {
        '& > label': {
            display: 'flex',
            flexDirection: 'row-reverse',
            justifyContent: 'flex-end',
            margin: 0,
        },
        '& .MuiTypography-root': {
            width: '100%',
            textTransform: "capitalize"
        }
    },
    accordion: {
        '& .MuiTypography-root': {
            width: '100%',
            textTransform: "capitalize"
        },
        '& .MuiAccordionDetails-root': {
            display: 'flex',
            flexWrap: 'wrap',
            '& > label': {
                display: 'flex',
                margin: 0,
                width: '33%'
            }
        }
    },
    submitForm: {
        width: '100%',
        marginTop: "10px",
        display: "flex",
        justifyContent: "flex-end"
    },
    deleteRole: {
        cursor: 'pointer',
        fontSize: '18px',
        color: "red",
    },
    updateRole: {
        cursor: 'pointer',
        fontSize: '18px',
    },
    editButtons: {
        position: 'absolute',
        top: '-5px',
        right: '-10px',
        zIndex: 9,
    }
});

const Teams = (props) => {
    const {classes, teams, countries, getActiveTeamUsers, user} = props;
    const [selectedteam, setSelectedteam] = React.useState(1);
    const [teamID, setTeamID] = React.useState(1);
    const [open, setOpen] = React.useState(false);
    const [updateModal, setUpdateModal] = React.useState(false);
    const [usersState, setUsersState] = React.useState('&equals[user_deactivated]=null');
    const [edit, setEdit] = React.useState(false)
    const [showDeleted, setShowDeleted] = React.useState(false)

    // Only people who manage user management may see deleted teams and restore them.
    const capabilities = user?.user_details?.capabilities || [];
    const canManageTeams = capabilities.some((c) => c.capability_title === 'manage_teams');

    React.useEffect(() => {
        // Get Teams (respecting the "Show deleted" toggle)
        props.getTeams({showDeleted: showDeleted && canManageTeams});

        // Get Countries
        props.getCountries();

        //GET USERS
        props.getUsers();
    }, [showDeleted, canManageTeams]);

    const teamSelection = (TeamID) => {
        setSelectedteam(TeamID);
    }

    const restoreTeam = (teamId) => {
        props.restoreTeam({id: teamId, showDeleted: true});
    }

    const handleClose = () => {
        setOpen(false);
        setUpdateModal(false);
    };

    const handleUpdateModal = (team_id) => {
        getActiveTeamUsers(`equals[team_id]=${team_id}`)
        setUpdateModal(true)
        setTeamID(team_id);
    }

    if (!countries || !teams) {
        return (
            <div style={{display: 'flex', justifyContent: 'center'}}>
                <CircularProgress/>
            </div>
        )
    }

    return (
        <>
            <div className={classes.container}>
                <Grid container spacing={2}>
                    <Grid item xs={2}>
                        <div style={{display: 'flex', justifyContent: 'space-between'}}>
                            <Typography
                                component="h5"
                                variant="h5"
                                style={{
                                    fontSize: "18px",
                                    color: "#9e9c9c",
                                    borderBottom: '1px solid #d0d0d0',
                                    marginBottom: "40px",
                                    paddingBottom: "10px",
                                }}
                            >
                                Teams
                            </Typography>
                            {
                                !edit && <div><img onClick={() => setEdit(true)} src={editIcon}
                                                   style={{width: '18px', cursor: 'pointer'}}/></div>
                            }

                            {
                                edit && <Check sx={{fontSize: '22px'}} onClick={() => setEdit(false)}/>
                            }

                        </div>
                        {
                            canManageTeams && (
                                <FormControlLabel
                                    control={
                                        <Switch
                                            size="small"
                                            checked={showDeleted}
                                            onChange={(e) => setShowDeleted(e.target.checked)}
                                        />
                                    }
                                    label="Show deleted"
                                    sx={{mb: 1, '& .MuiFormControlLabel-label': {fontSize: '13px', color: '#626262'}}}
                                />
                            )
                        }
                        <Grid container spacing={2}>
                            <Grid item xs={12} className={classes.roles}>
                                {
                                    teams && teams.rows.map((team, index) => {
                                        const isDeleted = !!team.deleted_at;
                                        return (
                                            <div style={{position: 'relative'}} key={index}>
                                                <Button
                                                    key={team.team_id}
                                                    variant="contained"
                                                    color="inherit"
                                                    className={selectedteam === team.team_id ? "selected" : ""}
                                                    onClick={(e) => teamSelection(team.team_id, e)}
                                                    sx={{
                                                        fontSize: '13px',
                                                        textTransform: 'capitalize',
                                                        opacity: isDeleted ? 0.5 : 1,
                                                    }}
                                                >
                                                    {team.team_name}
                                                    {isDeleted && (
                                                        <span style={{
                                                            marginLeft: '6px',
                                                            fontSize: '10px',
                                                            fontWeight: 'bold',
                                                            color: '#f44336',
                                                            textTransform: 'uppercase',
                                                        }}>
                                                            Deleted
                                                        </span>
                                                    )}
                                                </Button>
                                                <div className={classes.editButtons}>
                                                    {
                                                        isDeleted ? (
                                                            canManageTeams && (
                                                                <Button
                                                                    size="small"
                                                                    variant="outlined"
                                                                    color="primary"
                                                                    startIcon={<Restore sx={{fontSize: '16px'}}/>}
                                                                    onClick={() => restoreTeam(team.team_id)}
                                                                    sx={{fontSize: '10px', minWidth: 'auto', padding: '1px 6px'}}
                                                                >
                                                                    Restore
                                                                </Button>
                                                            )
                                                        ) : (
                                                            edit && (
                                                                <span className="deleteRole updateTeam">
                                                                    <img className={classes.updateRole}
                                                                         onClick={(e) => handleUpdateModal(team.team_id, e)}
                                                                         src={editIcon}
                                                                         style={{width: '18px', cursor: 'pointer'}}/>
                                                                </span>
                                                            )
                                                        )
                                                    }
                                                </div>
                                            </div>
                                        )
                                    })
                                }
                                <Button
                                    variant="contained"
                                    color="success"
                                    onClick={(_e) => {
                                        setOpen(true)
                                    }}
                                >
                                    Add New Team
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={10}>
                        <Grid container spacing={2}>
                            <Grid item xs={12}
                                  sx={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                                <Typography
                                    component="h5"
                                    variant="h5"
                                    style={{
                                        fontSize: "18px",
                                        color: "#9e9c9c",
                                        marginBottom: "20px",
                                        borderBottom: '1px solid #d0d0d0',
                                        paddingBottom: "10px",
                                    }}
                                >
                                    Users
                                </Typography>
                                <FormControl>
                                    <InputLabel id="user-state">Users</InputLabel>
                                    <Select
                                        labelId="user-state"
                                        id="user-state-options"
                                        value={usersState}
                                        label="Users"
                                        size="small"
                                        onChange={(e) => setUsersState(e.target.value)}
                                    >
                                        <MenuItem value={'&equals[user_deactivated]=null'}>Active</MenuItem>
                                        <MenuItem value={'&notequals[user_deactivated]=null'}>Not Active</MenuItem>
                                        <MenuItem value={'&users=all'}>Show All</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12}>
                                <TeamUsersGrid team={selectedteam} usersState={usersState}/>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </div>
            <AddTeam
                open={open}
                onClose={handleClose}
                countries={countries}
            />
            <AddTeam
                open={updateModal}
                onClose={handleClose}
                countries={countries}
                teams={teams}
                teamID={teamID}
                canManageTeams={canManageTeams}
                showDeleted={showDeleted && canManageTeams}
                onDeleted={() => setSelectedteam(null)}
            />
        </>
    );
}

const mapStateToProps = (state) => ({
    isLoading: adminSelectors.isLoading(state),
    user: accountSelectors.user(state),
    teams: usersSelectors.teams(state),
    countries: companiesSelectors.countries(state),

});

const mapDispatchToProps = (dispatch) => bindActionCreators(
    {
        getTeams: usersActions.getTeams,
        restoreTeam: usersActions.restoreTeam,
        getCountries: companiesActions.getCountries,
        getUsers: usersActions.getUsersList,
        getActiveTeamUsers: usersActions.getActiveTeamUsers,
    },
    dispatch
);

function WithNavigate(props) {
    let params = useParams();
    return <Teams {...props} params={params}/>;
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(useStyles)(WithNavigate));
